"use strict";

var _toConsumableArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toConsumableArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _compose = _interopRequireDefault(require("lodash/fp/compose"));

var _phases = _interopRequireDefault(require("./phases")); // Add start and end phases to enforce regularity in normal lifecycle phases


var primeLifecycle = function primeLifecycle(phases) {
  return [function (next) {
    return function () {
      return next({});
    };
  }].concat(_toConsumableArray(phases), [function () {
    return function () {};
  }]);
};

var lifecycle = function lifecycle(services) {
  var startLifecycle = (0, _compose.default)(primeLifecycle(Object.values(_phases.default).map(function (phase) {
    return phase.call(services);
  })));
  return {
    run: startLifecycle()
  };
};

var _default = lifecycle;
exports.default = _default;